import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },

  attachmentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  buttonsAttachmentFile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '110px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    borderRadius: '8px',
    padding: '16px'
  },
  attachmentPreviewImage: {
    maxWidth: 100,
    maxHeight: 90,
    objectFit: 'contain',
    borderRadius: '4px'
  },
  attachmentNotFile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontStyle: 'italic'
  },
  buttonsBoxAttachment: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  buttonFile: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    textTransform: 'none',
    padding: '6px 16px',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.blue_400?.main || '#2563eb'
    }
  },
  iconButtonDelete: {
    color: theme.palette.red_100.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(255, 0, 0, 0.04)'
    }
  },
  buttonsActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  }
}))
